import React from "react";
import { Grid, Box, Skeleton } from "@mui/material";
import SponsorCard from "~/components/Sponsors/Card";
import { useApiCall } from "~/single-page/hooks/useApiCall";
import SponsorsClient from "~/single-page/api/SponsorsClient";
import NoItemsMessage from "~/components/NoItemsMessage";

const SponsorsGrid = () => {
  const {
    data: sponsors = [],
    pending,
    success,
  } = useApiCall({
    apiCall: SponsorsClient.sponsors,
    init: true,
  });

  if (pending) {
    return (
      <Grid container spacing={3} justifyContent="center">
        {Array.from(new Array(6)).map((_, index) => (
          <Grid 
            item
            xs={6}
            sm={4}
            md={4}
            key={index}
          >
            <Skeleton 
              variant="rectangular" 
              height={150} 
              sx={{ 
                width: '100%',
                borderRadius: 2
              }} 
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!success || !sponsors.length) {
    return <NoItemsMessage itemName="patrocinador" gender="masculino" />;
  }

  const limitedSponsors = sponsors.slice(0, 6);

  return (
    <Grid container spacing={3} justifyContent="center">
      {limitedSponsors.map((sponsor, index) => (
        <Grid 
          item
          xs={6}   // 2 colunas no mobile
          sm={4}   // 3 colunas no tablet
          md={4}   // 3 colunas no desktop
          key={sponsor.id || index}
        >
          <SponsorCard sponsor={sponsor} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SponsorsGrid; 